/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VmcPoolOrgRequestStatusEnum } from './vmcPoolOrgRequestStatusEnum';
import { TaskV2 } from './taskV2';
import { VmcPoolOrgRequestStatusQuota } from './vmcPoolOrgRequestStatusQuota';
import { VmcPoolOrgRequestStatusVmcOrg } from './vmcPoolOrgRequestStatusVmcOrg';


export interface VmcPoolOrgRequestStatus { 
    in_progress_task?: TaskV2;
    quota?: VmcPoolOrgRequestStatusQuota;
    status: VmcPoolOrgRequestStatusEnum;
    vmc_org?: VmcPoolOrgRequestStatusVmcOrg;
}
export namespace VmcPoolOrgRequestStatus {
}


